import './dipTag.css'
export const DipTag = (props) => {
    return (
        <span className={`dip-tag ${props.className} ${props.hasLetterSpacing ? "dip-tag-letter-spacing" : ""}`}>
            {props.label}
        </span>
    )
}